import * as React from "react";

import { Provider } from "react-redux";
import { Provider as LocaleProvider } from "./components/localization/locale-context";
import MessageProvider from "./components/localization/message-provider";
import { localeStore } from "./i18n/locale-store";
// import './stylesheets/theme/theme.css'

import { store } from "./helpers";
import AppRouter from "./router";

interface IAppState {
  locale: string;
}

class App extends React.Component<{}, IAppState> {
  constructor(props: any) {
    super(props);

    this.state = { locale: localeStore.getLanguage() };
    this.setLocale = this.setLocale.bind(this);
  }

  public render() {
    const { locale } = this.state;

    return (
      <Provider store={store}>
        <LocaleProvider value={{ locale, setLocale: this.setLocale }}>
          <MessageProvider>
            <AppRouter />
          </MessageProvider>
        </LocaleProvider>
      </Provider>
    );
  }

  public setLocale(locale: string): void {
    localeStore.setLocale(locale);
    this.setState({ locale });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx